import React from 'react';
import '../App.css';
import {FaAngleDown, FaAngleUp} from 'react-icons/fa';

class Post extends React.Component{
    //console.log('In task');
    constructor(props){
      super(props);
      this.state={
        votePower:0
      }
    }
    componentDidMount(){
      this.setState({
        votePower:0
      })
    }

    handleUpvote=()=>{
      //console.log(this.state.canUpvote);
      let votePower=this.state.votePower;
      if(votePower<1){
        this.props.upvote();
        votePower++;
        this.setState((prevState)=>({
          votePower
        }))
      }
    }

    handleDownvote=()=>{
      let votePower=this.state.votePower;
      if(votePower>-1){
        this.props.downvote();
        votePower--;
        this.setState((prevState)=>({
          votePower
        }))
      }
    }

    render(){
      return(
        <div className="Post">
          <div className="PostScore">
            {this.props.post.score}
            <FaAngleUp onClick={this.handleUpvote}/>
            <FaAngleDown onClick={this.handleDownvote}/>
          </div>
          <div className="PostTitle">
            {this.props.post.title}
          </div>
          <div className="PostUser">
            {this.props.post.user}
          </div>
        </div>
      );
    }
}

export default Post;



// WEBPACK FOOTER //
// ./src/Components/IndividualPost.js